import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const PageHeader = ({ eyebrow, title, subtitle, ctaLabel = "Book a Consultation", ctaTo = "/contact" }) => {
  return (
    <section className="relative bg-navy text-white overflow-hidden" data-testid="page-header">
      <div className="absolute inset-0 grid-bg opacity-40" aria-hidden />
      <div className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-aqua/10 blur-3xl" aria-hidden />
      <div className="absolute -bottom-40 -right-40 w-[520px] h-[520px] rounded-full bg-aqua/10 blur-3xl" aria-hidden />
      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-24 lg:py-32">
        <p className="text-xs uppercase tracking-[0.22em] text-aqua font-semibold" data-testid="page-header-eyebrow">
          {eyebrow}
        </p>
        <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight max-w-4xl" data-testid="page-header-title">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-lg text-white/75 leading-relaxed" data-testid="page-header-subtitle">
            {subtitle}
          </p>
        )}
        {ctaLabel && (
          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to={ctaTo}
              data-testid="page-header-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-aqua px-6 py-3 text-[15px] font-medium text-navy hover:shadow-aqua-glow transition-all"
            >
              {ctaLabel}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-[15px] font-medium text-white hover:bg-white/5 transition-colors"
              data-testid="page-header-secondary"
            >
              Request a Cost Breakdown
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
